module.exports = __webpack_public_path__ + "img/line-analytics-md.22474d96.svg";